module.exports = __webpack_public_path__ + "static/media/persik.4e1ec840.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/persik.png
// module id = 97
// module chunks = 0